import { 
  FaFacebook, 
  FaTwitter, 
  FaInstagram, 
  FaYoutube,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaClock,
  FaWhatsapp
} from 'react-icons/fa';
import { motion } from 'framer-motion';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          
          {/* Ministry Info */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <h3 className="text-2xl font-bold mb-6 font-serif">Life Missions Ministry</h3>
            <p className="text-gray-300 mb-6">
              Bringing the light of Christ to the unreached since 2000 through evangelism, discipleship, and holistic transformation.
            </p>
            <div className="flex space-x-4">
              <a href="https://m.facebook.com/profile.php?id=61568641040883" className="text-gray-400 hover:text-white transition-colors">
                <FaFacebook className="text-2xl" />
              </a>
              <a href="/" className="text-gray-400 hover:text-white transition-colors">
                <FaTwitter className="text-2xl" />
              </a>
              <a href="/" className="text-gray-400 hover:text-white transition-colors">
                <FaInstagram className="text-2xl" />
              </a>
              <a href="/" className="text-gray-400 hover:text-white transition-colors">
                <FaYoutube className="text-2xl" />
              </a>
            </div>
          </motion.div>

          {/* Quick Links */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            viewport={{ once: true }}
          >
            <h4 className="text-xl font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li><a href="/" className="text-gray-300 hover:text-white transition-colors">Home</a></li>
              <li><a href="/" className="text-gray-300 hover:text-white transition-colors">About Us</a></li>
              <li><a href="/" className="text-gray-300 hover:text-white transition-colors">Our Impact</a></li>
              <li><a href="/" className="text-gray-300 hover:text-white transition-colors">Get Involved</a></li>
              <li><a href="/" className="text-gray-300 hover:text-white transition-colors">Blog/News</a></li>
              <li><a href="/" className="text-gray-300 hover:text-white transition-colors">Contact</a></li>
            </ul>
          </motion.div>

          {/* Ministry Programs */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <h4 className="text-xl font-semibold mb-6">Our Programs</h4>
            <ul className="space-y-3">
              <li><a href="/" className="text-gray-300 hover:text-white transition-colors">Church Planting</a></li>
              <li><a href="/" className="text-gray-300 hover:text-white transition-colors">Orphan Care</a></li>
              <li><a href="/" className="text-gray-300 hover:text-white transition-colors">Medical Ministry</a></li>
              <li><a href="/" className="text-gray-300 hover:text-white transition-colors">Leadership Training</a></li>
              <li><a href="/" className="text-gray-300 hover:text-white transition-colors">Community Development</a></li>
              <li><a href="/" className="text-gray-300 hover:text-white transition-colors">Education Initiatives</a></li>
            </ul>
          </motion.div>

          {/* Contact Info */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
            viewport={{ once: true }}
          >
            <h4 className="text-xl font-semibold mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start">
                <FaMapMarkerAlt className="text-gray-400 mt-1 mr-3 flex-shrink-0" />
                <span className="text-gray-300">Kitale<br />Trans-Nzoia County, Kenya</span>
              </li>
              <li className="flex items-center">
                <FaWhatsapp className="text-gray-400 mr-3" />
                <a href="https://wa.me/254707409123" className="text-gray-300 hover:text-white transition-colors">+254707409123</a>
              </li>
              <li className="flex items-center">
                <FaEnvelope className="text-gray-400 mr-3" />
                <a href="mailto:lifemissions21@gmail.com" className="text-gray-300 hover:text-white transition-colors">lifemissions21@gmail.com</a>
              </li>
              <li className="flex items-center">
                <FaClock className="text-gray-400 mr-3" />
                <span className="text-gray-300">Mon-Fri: 8AM - 5PM EAT</span>
              </li>
            </ul>
          </motion.div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-800 my-8"></div>

        {/* Bottom Footer */}
        <div className="flex flex-col md:flex-row justify-between items-center">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-gray-400 text-sm mb-4 md:mb-0"
          >
            © {new Date().getFullYear()} Life Missions Ministry. All rights reserved.
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
            className="flex space-x-6"
          >
            <a href="/" className="text-gray-400 hover:text-white transition-colors text-sm">Privacy Policy</a>
            <a href="/" className="text-gray-400 hover:text-white transition-colors text-sm">Terms of Service</a>
            <a href="/" className="text-gray-400 hover:text-white transition-colors text-sm">Financial Accountability</a>
          </motion.div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;